var $ = jQuery;

$(document).on('ready', function(){
    $(document).on('click', '.plusing', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        $('.plusing').not(this).removeClass('show');
        $('.plusing').not(this).find('.desc-area').removeClass('show');
        $(this).toggleClass('show');
        $(this).find('.desc-area').toggleClass('show');
    })
})
